<template>
  <div class="">
    <div class="lg:flex md:flex items-center gap-8 lg:px-10 md:px-8 px-5">
      <div class="lg:w-1/2 md:w-1/2 w-full mt-28">
        <Slider />
      </div>
      <div class="lg:w-1/2 md:w-1/2 w-full lg:mt-28 md:mt-28 mt-8">
        <Onboarding />
        <!-- <div class="preonboarding-footer term-policy-mt fsize14px">
          <div
            class="flex justify-center footer-txt-clr mt-6 lg:pl-0 md:pl-0 pl-4"
          >
            <div class="cursor-pointer md:mr-2 pr-2">
              <span class="h-class11 sm-fsize11 ">About Us</span>
            </div>
            |

            <div class="cursor-pointer md:ml-2 md:mr-2 pr-2 pl-4">
              <span class="h-class11 sm-fsize11 "> Privacy Policy</span>
            </div>
            |

            <div class="cursor-pointer md:ml-2 md:mr-2 pl-2 pr-2">
              <span class="h-class11 sm-fsize11 ">Terms &amp; Conditions </span>
            </div>
            |
            <div class="cursor-pointer md:ml-4 pr-2 pl-2">
              <span class="h-class11 sm-fsize11 ">Press Release</span>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <div>
      <PostRequirement ref="formOpen" />
    </div>
    <div class="">
      <BecomeService />
    </div>
    <div>
      <MyBookRespite />
    </div>
    <div class="lg:px-0 md:px-0 px-5">
      <FAQ />
    </div>
    <div class="bge3ceff-opa rounded-t-5555">
      <DownloadApp />
      <Footer />
    </div>
  </div>
</template>

<script>
import Slider from "./components/Slider.vue";
import Onboarding from "./components/Onboarding.vue";
import PostRequirement from "./components/PostRequirement.vue";
import BecomeService from "./components/BecomeService.vue";
import MyBookRespite from "./components/MyBookRespite.vue";
import FAQ from "./components/FAQ.vue";
import Footer from "../Footer.vue";
import DownloadApp from "@/views/home/components/DownloadApp.vue";
import { mapState } from "vuex";

export default {
  components: {
    Slider,
    Onboarding,
    PostRequirement,
    BecomeService,
    MyBookRespite,
    FAQ,
    Footer,
    DownloadApp,
  },
  computed: {
    ...mapState("auth", { user: "user" }),
  },
  async mounted() {
    if (this.$route.query.reqScroll) {
      const el = document.getElementById("serviceRequirementForm");
      el.scrollIntoView({ behavior: "smooth", block: "end" });
      this.$refs.formOpen.handleClick(true);
    }
    await this.$store.dispatch("respitecare/get_allbooking", {
      _id: this.user._id,
    });
  },
};
</script>

<style>
.fsize14px {
  font-size: 14px;
}
.footer-txt-clr {
  font-weight: 600;
  color: #777777 !important;
}
@media (max-width: 641px) {
  .sm-fsize11 {
    font-size: 11px;
  }
}
</style>
